<template>
  <Popup
    v-if="isVisible"
    :name="popupName"
    :extra-classes="['popup--full-width-on-mobile']"
    position="left bottom"
    context="global"
  >
    <template v-slot:content>
      <h3 class="after-tour__title">{{ t('tour.afterTourTitle') }}</h3>
      <div class="after-tour__content">
        <p>{{ t('tour.afterTourDescription') }}</p>
      </div>

      <div class="after-tour__actions">
        <button class="button button--primary" @click="hidePopup()">{{ t('global.ok') }}</button>
      </div>
    </template>
  </Popup>
</template>

<script setup>
  import Popup from '@/components/popups/Popup.vue'
  import { useSpecificPopup } from '@/composables/useSpecificPopup.ts'
  import { useTourStore } from '@/stores/useTourStore'
  import { useStrings } from '@/composables/useStrings.ts'

  const { t } = useStrings()
  const tourStore = useTourStore()
  const popupName = 'afterTour'

  const { isVisible, hide } = useSpecificPopup(popupName)
  const afterTourExplanationPopup = useSpecificPopup('afterTourExplanation')

  const hidePopup = () => {
    hide()
    tourStore.isTourComplete = true
    afterTourExplanationPopup.show()
  }
</script>

<style lang="scss">
  .after-tour {
    &__actions {
      display: flex;
      justify-content: space-between;

      & > *:only-child {
        margin-left: auto;
      }

      &__title {
        display: flex;
        justify-content: space-between;
        line-height: 1.2;

        &--1 {
          font-size: 1.8rem;
        }
      }

      &__page {
        float: right;
        line-height: 1;
        padding-left: $spacer10;
        padding-bottom: $spacer20;
      }

      &__content,
      .button--no-padding {
        font-size: 0.8rem;

        @media (min-width: $bp-lg) {
          font-size: 1rem;
        }
      }
    }
  }
</style>
